import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initGlitchTip } from './lib/sentry';
import ErrorBoundary from './components/ErrorBoundary';

// Handle dynamic chunk loading errors on new deployments
window.addEventListener('vite:preloadError', (event) => {
  const retryKey = 'voc_preload_retry';
  const lastRetry = sessionStorage.getItem(retryKey);
  const now = Date.now();

  // Allow one automatic reload within 10 seconds to fetch new build assets
  if (!lastRetry || now - Number(lastRetry) > 10000) {
    sessionStorage.setItem(retryKey, String(now));
    window.location.reload();
    return;
  }

  // If already retried, let the fatal error handler display the issue
  if (typeof (window as unknown as { __SHOW_FATAL_ERROR__?: (opts: unknown) => void }).__SHOW_FATAL_ERROR__ === 'function') {
    (window as unknown as { __SHOW_FATAL_ERROR__: (opts: unknown) => void }).__SHOW_FATAL_ERROR__({
      title: 'خطا در بارگذاری بخش‌های برنامه',
      reason: 'عدم امکان دریافت فایل‌های به‌روزرسانی شده وب‌سایت از سرور.',
      error: event,
      suggestion: 'احتمالاً نسخه جدیدی از سایت منتشر شده یا ارتباط شبکه قطع شده است. لطفاً کش مرورگر را پاک کنید.',
    });
  }
});

// Safely initialize error tracking without risking crash
try {
  initGlitchTip();
} catch (err) {
  console.warn('[GlitchTip] initialization failed:', err);
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  const fatalHandler = (window as unknown as { __SHOW_FATAL_ERROR__?: (opts: unknown) => void }).__SHOW_FATAL_ERROR__;
  if (typeof fatalHandler === 'function') {
    fatalHandler({
      title: 'خطای ساختار صفحه',
      reason: 'عنصر ریشه (root) در سند HTML یافت نشد.',
      error: new Error('Element #root not found'),
    });
  }
} else {
  try {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </StrictMode>,
    );

    // Notify early boot watchdog that application successfully mounted
    (window as unknown as { __APP_MOUNTED__?: boolean }).__APP_MOUNTED__ = true;
  } catch (err) {
    console.error('Fatal error during React root rendering:', err);
    const fatalHandler = (window as unknown as { __SHOW_FATAL_ERROR__?: (opts: unknown) => void }).__SHOW_FATAL_ERROR__;
    if (typeof fatalHandler === 'function') {
      fatalHandler({
        title: 'خطا در اجرای فرانت‌اند',
        reason: 'راه‌اندازی اولیه کامپوننت‌های ریشه با خطا متوقف شد.',
        error: err,
      });
    }
  }
}
